module.exports = __webpack_public_path__ + "img/product-placeholder-39.67870b0.png";